import { Injectable, signal, Renderer2, inject, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { StudentsService } from './students.service';
import { catchError, of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DarkThemeService {
	private renderer: Renderer2;

	private document = inject(DOCUMENT);
	private translate = inject(TranslateService);

	isDarkTheme = signal(false);

	private studentService = inject(StudentsService);

	constructor(rendererFactory: RendererFactory2) {
		this.renderer = rendererFactory.createRenderer(null, null);
	}

	checkThemeMode() {
		this.studentService
			.getStudents()
			.pipe(
				catchError(() => {
					return of(undefined);
				})
			)
			.subscribe((student) => {
				this.translate.use(student?.language ? student.language.replace('-', '_') : 'es_ES');
				this.changeThemeMode(student?.darkMode);
			});
	}

	changeThemeMode(darkMode: boolean | undefined | null) {
		// If the user has no preference, check the system default for dark theme
		const isDarkTheme =
			typeof darkMode !== 'boolean'
				? window.matchMedia('(prefers-color-scheme: dark)').matches
				: darkMode
				? true
				: false;
		this.isDarkTheme.set(isDarkTheme);
		if (isDarkTheme) {
			this.renderer.setAttribute(this.document.body, 'data-theme', 'dark');
		} else {
			this.renderer.removeAttribute(this.document.body, 'data-theme');
		}
	}
}
